import React, { Fragment } from "react";
import PropTypes from "prop-types";
import InternalLinkIcon from "../../../common/svg/InternalLinkIcon";
import RelativeLink from "../../../common/RelativeLink";
import moment from "moment";
import Row from "../../../common/Row";

const TabInfoComponent = (props) => {
    const {
        model,
        tab,
        rechtsvormen,
        sporttakken,
        doelgroepen,
        labels
    } = props;

    const linkIcon = InternalLinkIcon("#121212");
    const linkClass = { "color": "#39b4e8", "font-weight": "bold" };

    const modelInfo = Object.keys(model).map((t, i) => {
        let tekst = "";
        let label = "";
        let expAdressen = null;
        let corrAdressen = null;
        let maatAdressen = null;

        switch (t) {
            case "documentatie":
            case "logo":
                tekst = model[t] ? model[t].name : null;
                label = labels[t];
                break;
            case "oprichtDatum":
                tekst = moment(model[t]).format("DD-MM-YYYY");
                label = labels[t];
                break;
            case "rechtsvorm":
                tekst = rechtsvormen.find(r => r.value == model[t]).label;
                label = labels[t];
                break;
            case "isAangeslotenBijSportfederatie":
                tekst = model[t] === "true" ? "Ja" : "Nee";
                label = labels[t];
                break;
            case "sporttakken":
                tekst = model[t] ? model[t].filter(s => s.subsporttakken.length === 0).map(x => sporttakken.find(s => s.label.indexOf(x.naam) !== -1)).map(z => z.label.replace(/ - /g, ";")).join(", ") : null;
                label = labels[t];
                break;
            case "adressen":
                expAdressen = model[t] ? model[t].filter(a => a.soortAdres === 3).map(a => a.internationaalAdres ? a.land + " " + a.internationaalAdres : a.land + ", " + a.postcode + " " + a.gemeente + " " + a.straat + " " + a.huisnummer + " " + a.busnummer).join(", ") : null;
                corrAdressen = model[t] ? model[t].filter(a => a.soortAdres === 2).map(a => a.internationaalAdres ? a.land + " " + a.internationaalAdres : a.land + ", " + a.postcode + " " + a.gemeente + " " + a.straat + " " + a.huisnummer + " " + a.busnummer).join(", ") : null;
                maatAdressen = model[t] ? model[t].filter(a => a.soortAdres === 1).map(a => a.internationaalAdres ? a.land + " " + a.internationaalAdres : a.land + ", " + a.postcode + " " + a.gemeente + " " + a.straat + " " + a.huisnummer + " " + a.busnummer).join(", ") : null;
                tekst = <p>{expAdressen ? expAdressen : null}{expAdressen ? <br /> : null}{corrAdressen ? corrAdressen : null}{corrAdressen ? <br /> : null}{maatAdressen ? maatAdressen : null}{maatAdressen ? <br /> : null}</p>;
                label = <p>{expAdressen ? "Adres waar thuiswedstrijden/trainingen doorgaan" : null}{expAdressen ? <br /> : null}{corrAdressen ? "Correspondentieadres" : null}{corrAdressen ? <br /> : null}{maatAdressen ? "Maatschappelijke zetel" : null}{maatAdressen ? <br /> : null}</p>;
                break;
            case "doelgroepen":
                tekst = model[t] ? doelgroepen.filter(d => model[t].indexOf(d.value) !== -1).map(x => x.label).join(", ") : null;
                label = labels[t];
                break;
            default:
                tekst = model[t] ? model[t] : null;
                label = labels[t];
                break;
        }

        return (
            tekst ? <Row><p className="o-col-6">{label}</p><p className="o-col-6">{tekst}</p></Row> : null
        );
    });

    return (
        <Fragment>
            <p>
                <RelativeLink style={linkClass} to={tab.url} title={tab.title}>
                    {linkIcon} {tab.title}
                </RelativeLink>
            </p>
            {modelInfo}
            <br />
        </Fragment>
    );
};

TabInfoComponent.defaultProps = {

};

TabInfoComponent.propTypes = {
    model: PropTypes.object,
    tab: PropTypes.object,
    rechtsvormen: PropTypes.array,
    sporttakken: PropTypes.array,
    doelgroepen: PropTypes.array,
    labels: PropTypes.object
};

export default TabInfoComponent;